// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import Table from "../../../../components/Table";

// MARK: Stores
import GastroPlaceStore from "../../../../stores/GastroPlaceStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	gastroPlaceStore: GastroPlaceStore;
}

@inject("gastroPlaceStore")
@observer
export default class GastroPlacesTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.gastroPlaceStore.getGastroPlaces();
	}

	public render() {
		const { gastroPlaceStore } = this.props;
		return (
			<>
				<Table
					title={strings.gastroPlaces.title}
					rows={gastroPlaceStore.gastroPlacesTableRows}
					header={gastroPlaceStore.header}
					pageOffset={gastroPlaceStore.pageOffSet}
					loading={gastroPlaceStore.loading}
					tableIsEmptyMessage={strings.gastroPlaces.table.tableIsEmpty}
					prevPage={gastroPlaceStore.previousPage}
					nextPage={gastroPlaceStore.nextPage}
					onAddClick={() => gastroPlaceStore.startGastroPlaceCreateOrEdit()}
					onEditClick={(gastroPlaceId) => gastroPlaceStore.startGastroPlaceCreateOrEdit(gastroPlaceId)}
					onDeleteClick={(gastroPlaceId, gastroPlaceName) => gastroPlaceStore.openDeleteGastroPlaceDialog(gastroPlaceId, gastroPlaceName)}
				/>
			</>
		);
	}
}
